// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"footer-slim_footerContainer__zeg8T","copyright":"footer-slim_copyright__Zg7Tw","links":"footer-slim_links__3Zv_x","address":"footer-slim_address__9nA8l"};